import { createContext, useContext, useState } from "react";

const AdminEmailsContext = createContext();

export const AdminEmailsProvider = ({ children }) => {
  const [adminMails, setAdminMails] = useState([]);
  const [allowedCheckTypes, setAllowedCheckTypes] = useState([]);

  return (
    <AdminEmailsContext.Provider
      value={{
        adminMails,
        setAdminMails,
        allowedCheckTypes,
        setAllowedCheckTypes,
      }}
    >
      {children}
    </AdminEmailsContext.Provider>
  );
};

export const useAdminMails = () => {
  const context = useContext(AdminEmailsContext);

  if (!context) {
    throw new Error("useAdminMails must be used within AdminEmailsProvider");
  }

  return context;
};
